export default {
  _name: 'dark',
  _appearance: 'dark',

  background: '#28334c',
  border: '#2c3a58',
  overlay: '#28334c',
  content: '#FFFFFF',
  contentSecondary: '#7c99d6',

  surface: '#35425e',
  surfaceContent: '#FFFFFF',
  surfaceContentSecondary: '#7c99d6',
  surfaceIcon: '#6683c3',
  surfaceUnder: '#2d3954',
  surfaceOpened: '#7c99d6',
  surfaceSelected: '#405071',
  surfaceHighlight: '#405071',
  surfacePressed: '#3f4e6d',
  surfaceInteractive: '#405071',

  feedbackSurface: '#4c5d82',
  feedbackSurfaceContent: '#212B36',
  feedbackSurfaceContentSecondary: '#637381',

  warning: '#ffa410',
  warningSurface: '#656569',
  warningSurfaceContent: '#ffa410',

  info: '#00d2ff',
  infoSurface: '#415279',
  infoSurfaceContent: '#18d4fb',

  help: '#7C80F2',
  helpContent: '#FFFFFF',
  helpSurface: '#FFFFFF',
  helpSurfaceContent: '#212B36',

  negative: '#FF6969',
  negativeContent: '#FFFFFF',
  negativeSurface: '#655c72',
  negativeSurfaceContent: '#ff5454',

  positive: '#2cc68f',
  positiveContent: '#FFFFFF',
  positiveSurface: '#35585e',
  positiveSurfaceContent: '#1B8962',

  badge: '#415279',
  badgeContent: '#ffffff',
  badgePressed: '#4c5d82',

  tagIdentifier: '#564090',
  tagIdentifierContent: '#b6a1ff',

  tagNew: '#35585e',
  tagNewContent: '#2cc68f',

  tagIndicator: '#415279',
  tagIndicatorContent: '#00d3ff',

  tagActivity: '#00d2ff',
  tagActivityContent: '#FFFFFF',

  hint: '#6683c3',
  link: '#0ca5ff',
  focus: '#0ca5ff',
  selected: '#08BEE5',
  selectedContent: '#FFFFFF',
  selectedDisabled: '#212B36',

  disabled: '#3f4e6f',
  disabledContent: '#8497bf',
  disabledIcon: '#6683c3',

  control: '#57698c',
  controlBorder: '#2c3a58',
  controlBorderPressed: '#65779a',
  controlDisabled: '#3f4e6f',
  controlSurface: '#F9FAFC',
  controlUnder: '#F1F3F7',

  accent: '#08BEE5',
  accentStart: '#32fff5',
  accentEnd: '#08BEE5',
  accentContent: '#FFFFFF',

  floating: '#1c2539',
  floatingContent: '#FFFFFF',

  green: '#9BC75A',
  yellow: '#F7D858',
  red: '#F08658',
  blue: '#3E7BF6',
  brown: '#876559',
  purple: '#7C80F2',
}
